export default __webpack_public_path__ + "static/media/tutorial-07.4eaa3c9e.jpg";